import { Subject } from "rxjs";

import setting from "../store/modules/app";
import log2 from "./log2";
import socketStatus from "../store/modules/socketStatus";

const messages = new Subject();
const log = log2("SocketStream");
export const addMessage = (cmd, data) =>
    messages.next({
        cmd,
        data,
    });
export const sendSocketMessage = (type, payload) => {
    log("send socket message", type, payload);
    const socket = socketStatus.state.current_socket;
    if (socket === null) return;
    if (!setting.state.multiSessionMode) {
        socket.emit(type, payload);
    } else {
        log.warn("***Cannot send Message to socket in multi session mode ");
    }
};

export const socketMessageStream = messages.asObservable();
